// @flow
import config from '../../config';
import { makeAPICall, APIError } from '../generalCreators';
import {
  getOrganisation,
  getOrganisations
} from '../organisations/basicCreators';
import type { ThunkAction } from '../../types';

export function getCurrentCustomerLocations(
  organisationId: any,
  withPermissions: boolean = true,
  excludeArchived: boolean = false
): ThunkAction {
  return function(dispatch, getState) {
    const endpoint = '/organisations/access';
    const options = {
      method: 'GET',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId,
        withPermissions,
        excludeArchived
      }
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const locations = response.data.organisations;
        dispatch({ type: 'UPDATE_CURRENT_CUSTOMER_LOCATIONS', locations });
        return response;
      },
      error => dispatch(APIError(error, 'Error getting customer Locations'))
    );
  };
}

export function setCurrentCustomerCurrentLocation(
  organisationId: any,
  withSettings: boolean = true
): ThunkAction {
  return function(dispatch) {
    return dispatch(getOrganisation(organisationId, withSettings)).then(
      orgWithSettings => {
        const location = orgWithSettings;
        const settings = orgWithSettings.settings;
        dispatch({
          type: 'SET_CURRENT_CUSTOMER_CURRENT_LOCATION',
          location,
          settings
        });
      }
    );
  };
}

export function clearCurrentCustomerCurrentLocation(): ThunkAction {
  return function(dispatch) {
    dispatch({ type: 'CLEAR_CURRENT_CUSTOMER_CURRENT_LOCATION' });
  };
}

export function addCurrentCustomerLocation(
  location: Object,
  customerId: any,
  setAllPermissions: boolean = true
): ThunkAction {
  location.canSendToNoJunkMail = false;
  location.canSendToDoNotMail = false;
  return function(dispatch, getState) {
    const endpoint = '/organisations';
    const options = {
      method: 'POST',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId: customerId,
        setAllPermissions
      },
      data: location
    };
    return makeAPICall(endpoint, options).then(
      response => {
        const newLocationId = response.data.id;
        dispatch(getCurrentCustomerLocations(customerId));
        dispatch(getOrganisations(customerId));
        dispatch(setCurrentCustomerCurrentLocation(newLocationId));
        return response;
      },
      error => dispatch(APIError(error, 'Error creating a location'))
    );
  };
}

export function updateCurrentCustomerLocation(
  location: Object,
  customerId: any
): ThunkAction {
  return function(dispatch, getState) {
    // default to current date if the location does not have a dateUpdated field - fix for seeded data
    if (!location.dateUpdated) {
      location.dateUpdated = new Date().toISOString();
    }

    const endpoint = '/organisation';
    const options = {
      method: 'PUT',
      headers: { token: getState().authentication.token },
      params: {
        productId: config.productId,
        organisationId: location.id
      },
      data: location
    };
    return makeAPICall(endpoint, options).then(
      response => {
        dispatch(getCurrentCustomerLocations(customerId));
        dispatch(setCurrentCustomerCurrentLocation(location.id));
        return response;
      },
      error => dispatch(APIError(error, 'Error updating location'))
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/customers/locationCreators.js